import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IConfigComponent, CUnit } from '@ts/ui-models';
import { IDataGridConfig, generateGlobalColumns, generateBasicColumn } from '@ts/storybook';

interface IUnitsProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'units',
  aclId: 'unit',
  entity: 'unit',
  fetchURL: '/api/units',
  crudURL: '/api/unit',
  mainClass: CUnit,
};

const Units = (props: IUnitsProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(undefined, undefined, { editable: true }),
      generateBasicColumn({ field: 'abbreviation' }, { field: 'abbreviation' }),
      generateBasicColumn({ field: 'quantity' }, { field: 'quantity.name' }),
      generateBasicColumn(
        { field: 'conversionToSIBasic', headerName: 'Conversion to SI basic' },
        { field: 'conversionToSIBasic' }
      ),
      generateBasicColumn({ field: 'system' }, { field: 'system' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{ message: 'This will also erase associations related to the item' }}
      inheritedProps={inheritedProps}
    />
  );
};

export default Units;
